import styles from './Process.module.scss'
import { useRef } from 'react'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'

export interface ProcessItem {
  title: string
  term?: string
  text: string
  deliverables?: {
    name: string
  }[]
  content?: {
    title: string
    text: string
    src?: string
    srcHeight?: string
    customElements?: JSX.Element
  }[]
}

interface Props {
  list: ProcessItem[]
  isVisibleAnnotation?: boolean
}

const Process: React.FC<Props> = ({ list, isVisibleAnnotation }) => {
  const animeRef = useRef<HTMLDivElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)

  return (
    <section
      className={`${styles.wrapper} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      <h2 className={styles.sectionTitle}>導入ステップ</h2>
      <p className={styles.sectionRead}>お客様の状況に合わせてプロジェクトの進め方を提案いたします</p>
      <div className={styles.process}>
        <ul className={styles.process__container}>
          {list.map((item, index) => {
            const isLast = index === list.length - 1
            return (
              <li key={index} className={styles.process__item}>
                <div className={styles.process__item__num}>0{index + 1}</div>
                <div className={styles.process__rights}>
                  <div className={styles.process__rights__head}>
                    <h4 className={styles.process__rights__head__title}>
                      <span>{item.title}</span>
                      <span className={styles.process__rights__head__title__terms}>{item.term}</span>
                    </h4>
                    <p
                      className={`${styles.process__rights__head__detail} ${styles.process__rights__head__detail__last}`}
                    >
                      {item.text}
                    </p>
                  </div>
                  {item.deliverables && (
                    <div className={styles.process__rights__bottom}>
                      <p className={styles.process__rights__bottom__text}>成果物</p>
                      <div className={styles.process__rights__bottom__items}>
                        {item.deliverables.map((deliverable, i) => (
                          <p key={i} className={styles.process__rights__bottom__items__link}>
                            {deliverable.name}
                          </p>
                        ))}
                      </div>
                    </div>
                  )}
                  {item.content && (
                    <div className={styles.process__rights__contents}>
                      {item.content.map((content, i) => {
                        return (
                          <div key={i} className={styles.process__rights__contents__content}>
                            <p className={styles.process__rights__contents__content__title}>{content.title}</p>
                            <p className={styles.process__rights__contents__content__text}>{content.text}</p>
                            {content.src && (
                              <img
                                src={content.src}
                                alt="process"
                                className={styles.process__rights__contents__content__img}
                                style={{
                                  height: content.srcHeight ? `${content.srcHeight} !important` : '',
                                  objectFit: content.srcHeight ? `contain` : 'cover',
                                }}
                              />
                            )}
                          </div>
                        )
                      })}
                    </div>
                  )}
                  {isLast && isVisibleAnnotation && (
                    <p className={styles.annotation__text}>
                      ※当内容をベースに、お客さまと協議の上、実際のプロジェクト範囲とタスク、期間を定義して進めます。
                    </p>
                  )}
                </div>
              </li>
            )
          })}
        </ul>
      </div>
    </section>
  )
}

export default Process
